import { axiosInstance, getFullHeader } from '@services/base-service';

const transactionsUri = '/merchant/bff/transactions';

const buildBlockingsUrl = () => `${transactionsUri}/blockings`;

export const getBlockings = async () =>
  axiosInstance.getInstance().get(buildBlockingsUrl());